import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme.js';

import SearchField from '../SearchField';
import ArticleSummary from '../ArticleSummary';
import Button from '../Button';

const SEARCH_ICON = require('./search.svg');
const CLOSE_ICON = require('./close.svg');

export default class SearchOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: [],
    };
  }

  _closeOverlay() {
    this.props.closeHandler();
  }

  _setSearchQuery(key, query) {
    this.props.queryHandler(query);
  }

  _viewAllResults() {
    this.props.history.push("/search");
    this.props.closeHandler();
  }

  getPosts() {
    return this.props.results && this.props.results.length ? this.props.results.slice(0,3).map((post) => {
      return (
        <ArticleSummary
          key={`${post.id}_${post.slug}`}
          post={post} />
      );
    }) : false;
  }

  render() {
    return (
      <div className={css(styles.overlay_container)}>
        <div className={css(styles.clickable_container)} onClick={this._closeOverlay.bind(this)} />
        <div className={css(styles.container)}>
          <div onClick={this._closeOverlay.bind(this)} className={css(styles.close_container)}>
            <div className={css(styles.close_text)}>Close</div> <img src={CLOSE_ICON} className={css(styles.close_icon)} />
          </div>
          <div className={css(styles.search_container)}>
            <img src={SEARCH_ICON} className={css(styles.search_icon)} />
            <div className={css(styles.search_input_container)}>
              <SearchField value={this.props.query} handler={this._setSearchQuery.bind(this)} />
            </div>
          </div>
          <div className={css(styles.num_results)}>
            <div className={css(styles.num_results_text)}>{this.props.results.length} results found</div>
          </div>
          <div className={css(styles.articles_container)}>
            { this.getPosts() }
            {
              this.props.results.length > 3 ? (
                <div className={css(styles.load_more_container)}>
                  <Button title="View all results" handler={this._viewAllResults.bind(this)} />
                </div>
              ) : false
            }
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  overlay_container: {
    position: 'fixed',
    zIndex: 100,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    overflowY: 'scroll',
    boxSizing: 'border-box',
    backgroundColor: 'rgba(5,9,14,0.8)',
  },
  clickable_container: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 1,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  container: {
    position: 'relative',
    zIndex: 10,
    padding: 50,
    width: Theme.container_width - (Theme.margin_width * 2),
    margin: '0 auto',
  },
  close_container: {
    textAlign: 'right',
    marginRight: 30,
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.5,
    },
  },
  close_text: {
    display: 'inline-block',
    fontFamily: Theme.fontFamily,
    letterSpacing: 1,
    fontSize: 11,
    color: Theme.white,
    textTransform: 'uppercase',
  },
  close_icon: {
    position: 'relative',
    top: 1,
    width: 10,
    height: 10,
  },
  search_container: {
    display: 'flex',
    marginRight: 30,
    borderBottom: `1px solid ${Theme.grey}`,
    alignItems: 'center',
  },
  search_icon_container: {
    flex: 1,
  },
  search_icon: {
    marginRight: 30,
    marginBottom: 10,
  },
  'search_input_container': {
    flex: 9,
  },
  articles_container: {
    paddingTop: 30,
    paddingBottom: 100,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: "wrap"
  },
  num_results: {
    display: 'block',
    marginTop: 30,
  },
  num_results_text: {
    fontFamily: Theme.fontFamily,
    color: Theme.white,
    fontSize: 10,
    letterSpacing: 2,
    textTransform: 'uppercase',
  },
  load_more_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
});



// WEBPACK FOOTER //
// ./src/components/SearchOverlay/index.js